module.exports = __webpack_public_path__ + "static/media/058-lifebuoy.6a70c783.svg";